import { match } from 'react-router'

export default {

  analyticsExists() {
    return typeof window.analytics !== 'undefined'
  },

  init(history, routes) {
    history.listen(location => this.listen(location, routes))
  },

  listen(location, routes) {
    match({ routes, location }, this.match.bind(this))
  },

  match(error, redirectLocation, renderProps) {
    const { routes, params } = renderProps
    const { contentGroup } = renderProps.routes[routes.length - 1]

    if (this.analyticsExists()) {
      window.analytics.page({ ...params, contentGroup })
    }
  },

  track(name, properties) {
    if (this.analyticsExists()) {
      window.analytics.track(name, properties)
    }
  },

}



/** WEBPACK FOOTER **
 ** ./src/utils/analytics/analytics.js
 **/